<template>
  <div ref="scrollTarget"></div>
  <div class="container-fluid" style="height: 100%;">
    <div class="row">
      <!-- Left Side Menu -->
      <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block sidebar">
        <div class="position-sticky" style="margin-top: 50px;">
          <ul class="nav flex-column" style="padding-left: 5%; margin-top: 10px;">
            <router-link to="/dashboard" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/dash1.png" class="img-item"
                  style="margin-right: 12px;">
                {{
                  translate('dashboard')
                }}</li>
            </router-link>
            <router-link to="/orders-validate" style="color: #000;">
              <li class="nav-item custom active-item"><img src="../assets/img/wait_icon.svg" class="img-item"> {{
                translate('shipments_to_validate') }} <span v-if="pending_orders_notification > 0">({{
                  pending_orders_notification }})</span>
              </li>
            </router-link>
            <router-link to="/progress-orders" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/progress_icon.svg" class="img-item"> {{
                translate('shipment_progress') }} <span v-if="progress_orders_notification > 0">({{
                  progress_orders_notification }})</span>
              </li>
            </router-link>
            <router-link to="/delivered-orders" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/Check.svg" class="img-item"> {{
                translate('shipment_deleivred') }}
              </li>
            </router-link>
            <router-link to="/commissions" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/dash4.png" class="img-item"
                  style="margin-right: 12px;">
                {{
                  translate('commissions') }}</li>
            </router-link>
            <router-link to="/new_order" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/dash5.png" class="img-item"
                  style="margin-right: 12px;">
                {{
                  translate('new_shipment') }}</li>
            </router-link>
            <router-link v-if="company.bonus" to="/mybonus" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/bonus_icon.svg" class="img-item" style="margin-right: 12px;">
                {{translate('bonus') }} 
                <span style="margin-left: 5px; background-color: #E5097F; color: white; padding: 3px 8px 3px 8px; border-radius: 20px; font-weight: bold;">{{ company.bonus_points }} pts</span>
              </li>
            </router-link>
          </ul>

          <ul class="nav flex-column" style="margin-top: 400px; padding-left: 5%; margin-bottom: 10px;">
            <router-link to="/company" style="color: #000;">
              <li class="nav-item custom"><img src="../assets/img/dash6.png" class="img-item"> {{
                translate('my_company')
                }}</li>
            </router-link>
            <li class="nav-item custom" @click="logout()"><img src="../assets/img/dash8.png" class="img-item"> {{
              translate('sign_out') }}</li>
          </ul>
        </div>
      </nav>

      <!-- Content Area -->
      <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4" style=" background-color: #F7F7F8;">

        <div class="row justify-content-between" style="padding-right: 50px; padding-left: 50px; margin-top: 30px;">
          <div class="col-auto">
            <p style="font-weight: bold; color: black;">{{ translate('hello') }} {{ user.first_name }} <br> <span
                style="font-weight: 400;">
                {{ translate('welcome_back') }}
              </span></p>
          </div>
          <router-link to="/company" class="col-auto" style="cursor: pointer;">
            <p style="color: #E5097F; font-weight: bold;"> <i class="fa fa-building-o" aria-hidden="true"
                style="margin-right: 10px; font-size: 25px;"></i> {{ company.company_name }} </p>
          </router-link>
        </div>



        <div class="row justify-content-center" style="margin-top: 20px; margin-bottom: 100px;">
          <!-- First Table -->
          <div class="col-12 text-center">
            <div>
              <div class="row justify-content-center">
                <div class="col-md-8 mb-4">
                  <div class="card mb-4" style="border-radius: 20px;">
                    <div class="card-header py-3"
                      style="background-color: #E5097F; border-top-right-radius: 20px; border-top-left-radius: 20px;">
                      <h5 class="mb-0" style="color: white; font-weight: bold;"><img
                          src="../assets/img/shipment_info_icon.svg"
                          style="transform: scale(1.5); margin-right: 8px; margin-left: 5px;"> Validation of Shipment {{
                            shipment_id }} </h5>
                    </div>
                    <div class="card-body">
                      <form>
                        <div class="row">
                          <div class="form-group mb-1 col-12">
                            <div class="row mb-4">
                              <div class="col-md-7">
                                <div class="d-flex align-items-center">
                                  <label class="label-form"
                                    style="margin-bottom: 10px; color: black; font-weight: 600;">{{
                                      translate("shipping_date") }}: </label>
                                  <Datepicker style="width : 60%; margin-left: 15px;" v-model="selectedDate"
                                    :format="dateFormat" :disabled-dates="disabledDates" :min-date="today"
                                    :max-date="maxDate"
                                    :class="{ 'fill-out': selectedDate, 'not-fill-out': !selectedDate }" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="text-end">
                            <template v-if="selectedDate">
                              <button type="button" class="btn btn-next-active btn-lg btn-block"
                                style="font-size: 18px; padding: 0; width: 100px; border-radius: 10px;"
                                @click="getDelivery_time">
                                {{ translate('next') }}
                              </button>
                            </template>
                            <template v-else>
                              <button type="button" class="btn btn-next-deactive btn-lg btn-block"
                                style="font-size: 18px; padding: 0; width: 100px; border-radius: 10px;"
                                @click="checkFields">
                                {{ translate('next') }}
                              </button>
                            </template>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <template v-if="delivery_date && transporter && selectedDate">
                    <div class="card mb-4" style="border-radius: 20px;">
                      <div class="card-header py-3"
                        style="background-color: #E5097F; border-top-right-radius: 20px; border-top-left-radius: 20px;">
                        <h5 class="mb-0" style="color: white; font-weight: bold;">
                          <i class="fa fa-clock-o" style="margin-right: 8px; font-size: 18px;"></i>{{
                            translate('delivery_date_pickup_time') }}
                        </h5>
                      </div>
                      <div class="card-body">
                        <form>
                          <div class="row">
                            <div class="form-group col-12">
                              <div class="row">
                                <div class="col-md-8">
                                  <div class="d-flex align-items-center">
                                    <label class="label-form"
                                      style="margin-bottom: 10px; color: black; font-weight: 600;">{{
                                        translate("delivery_estimate") }}: <span style="color: #E5097F;">{{
                                        formattedDeliveryTime() }}</span> </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-8" style="text-align: left;">
                              <span style="font-weight: 600; color: black;"> {{ translate('pickup_time_phrase')
                                }}</span>
                              <div class="row" style="margin-top: 15px;">
                                <div class="col">
                                  <div class="form-outline">
                                    <select class="form-control" v-model="ready_time">
                                      <option value="" disabled selected>{{ translate('from_pickuptime') }}</option>
                                      <option v-for="instancetime in availableStartTimes" :value="instancetime">{{
                                        instancetime }}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="form-outline">
                                    <select class="form-control" v-model="close_time">
                                      <option value="" disabled selected>{{ translate('to_pickuptime') }}</option>
                                      <option v-for="instancetime2 in availableCloseTimes" :value="instancetime2">{{
                                        instancetime2 }}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="booking_error" class="booking-refused">
                              <div style="font-weight: 700; margin-bottom: 4px;">{{ translate('booking_refused_title') }}</div>
                              <div>{{ booking_error }}</div>
                              <button type="button" class="btn btn-fix-desc" @click="$router.push('/edit-shipment/' + shipment_id)">
                                {{ translate('fix_description') }}
                              </button>
                            </div>
                            <div class="text-end">
                              <template v-if="ready_time && close_time">
                                <button type="button" class="btn btn-next-active btn-lg btn-block"
                                  style="font-size: 18px; padding: 0; width: auto; border-radius: 10px; padding-left: 7px; padding-right: 7px;"
                                  @click="AskValidation">
                                  {{ translate('validate_order') }}
                                </button>
                              </template>
                              <template v-else>
                                <button type="button" class="btn btn-next-deactive btn-lg btn-block"
                                  style="font-size: 18px; padding: 0; width: auto; border-radius: 10px; padding-left: 7px; padding-right: 7px;"
                                  @click="checkFields2">
                                  {{ translate('validate_order') }}
                                </button>
                              </template>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Chart from 'chart.js/auto';
import { toast } from 'bulma-toast'
import en from '../en.js';
import fr from '../fr.js';
import nl from '../nl.js';
import Swal from 'sweetalert2'
import '@vuepic/vue-datepicker/dist/main.css';
import Datepicker from '@vuepic/vue-datepicker';
import { ref } from 'vue';

export default {
  name: 'Dashboard',
  mixins: [en, fr, nl],
  components: {
    Datepicker
  },
  setup() {
    const date = ref();
    const dateFormat = 'dd-MM-yyyy';

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Check if the current hour is past 18:00
    const currentHour = new Date().getHours();
    const isPast17 = currentHour >= 17;

    if (isPast17) {
      today.setDate(today.getDate() + 1);
    }

    // Calculate the disabled dates (weekends)
    const disabledDates = (date) => {
      const dayOfWeek = date.getDay();
      return dayOfWeek === 0 || dayOfWeek === 6;
    };

    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + 7);

    return {
      date,
      dateFormat,
      today,
      maxDate,
      disabledDates
    };
  },
  data() {
    return {
      user: {},
      today_shipments: "",
      progress_shipments: "",
      delivered_shipments: "",
      all_shipments: "",
      shipments_statistics: [],
      commissions_statistics: [],
      commission_amount: "",
      shipments: [],
      company: {},
      selectedShipment: null,
      selectedDate: "",
      shipment_id: "",
      booking_error: "",
      delivery_date: "",
      transporter: "",
      availableStartTimes: [],
      availableCloseTimes: [],
      ready_time: "",
      close_time: "",
      pending_orders_notification: 0,
      progress_orders_notification: 0
    }
  },
  watch: {
    selectedDate(newVal) {
      this.calculateAvailableStartTimes();
    },
    ready_time(newVal) {
      this.updateCloseTimeOptions();
    },
  },
  computed: {
    lang() {
      return this.$store.state.lang
    },
    specialPostalCodes() {
      return [1000, 1030, 1040, 1050, 1060, 1070, 1080, 1081, 1082, 1083, 1090, 1140, 1150, 1160, 1170, 1180, 1190, 1200];
    },
  },
  async created() {
    this.$store.commit('setIsLoading', true)
    await axios.get('/api/v1/users/me/')
      .then(async response => {
        this.user = response.data
        await this.getServicePoint(this.user.id)
      })
      .catch(error => {
        console.log(error)
      })
    this.$store.commit('setIsLoading', false)

  },
  async mounted() {
    document.title = 'Validate Shipment | Orders';
    const element = this.$refs.scrollTarget;
    element.scrollIntoView({ behavior: 'smooth' });
    window.scrollTo(0, 0);

    this.shipment_id = this.$route.params.shipment_id
    await this.getNotifications()

    //----------------pickup date------------------------
    if (this.specialPostalCodes.includes(parseInt(this.$store.state.shipment.sender.postal_code))) {
      const belgiumTimezone = 'Europe/Brussels';
      const optionsss = { timeZone: belgiumTimezone };
      const now = new Date().toLocaleString('en-US', optionsss);
      const currentHour = new Date(now).getHours();
      const currentMinute = new Date(now).getMinutes();
      const currentDayOfWeek = new Date(now).getDay();

      const minDate = new Date();

      if (currentHour > 16 || (currentHour === 16 && currentMinute >= 30)) {
        if (currentDayOfWeek === 5) {
          minDate.setDate(minDate.getDate() + 3);
        } else if (currentDayOfWeek === 6) {
          minDate.setDate(minDate.getDate() + 2);
        } else {
          minDate.setDate(minDate.getDate() + 1);
        }
      }

      minDate.setHours(0, 0, 0, 0);

      this.today = minDate;

      if (currentHour > 16 || (currentHour === 16 && currentMinute >= 30)) {
        this.selectedDate = minDate;
      }
    } else {
      const belgiumTimezone = 'Europe/Brussels';
      const optionsss = { timeZone: belgiumTimezone };
      const now = new Date().toLocaleString('en-US', optionsss);
      const currentHour = new Date(now).getHours();
      const currentMinute = new Date(now).getMinutes();
      const currentDayOfWeek = new Date(now).getDay();

      const minDate = new Date();

      if (currentHour > 15 || (currentHour === 15 && currentMinute >= 30)) {
        if (currentDayOfWeek === 5) {
          minDate.setDate(minDate.getDate() + 3);
        } else if (currentDayOfWeek === 6) {
          minDate.setDate(minDate.getDate() + 2);
        } else {
          minDate.setDate(minDate.getDate() + 1);
        }
      }

      minDate.setHours(0, 0, 0, 0);

      this.today = minDate;

      if (currentHour > 15 || (currentHour === 15 && currentMinute >= 30)) {
        this.selectedDate = minDate;
      }
    }

  },
  methods: {
    translate(prop) {
      return this[this.lang][prop];
    },
    async getNotifications() {
      await axios.post('/api/v1/get-notifications/')
        .then(response => {
          this.pending_orders_notification = response.data['pending_orders']
          this.progress_orders_notification = response.data['progress_orders']
        })
        .catch(error => {
          console.log(JSON.stringify(error))
        })
    },
    async bookShipment() {
      this.$store.commit('setIsLoading', true)

      const date = new Date(this.selectedDate);
      const toTwoDigits = (num) => {
        return num < 10 ? '0' + num : '' + num;
      };

      const day = toTwoDigits(date.getDate());
      const month = toTwoDigits(date.getMonth() + 1);
      const year = date.getFullYear();
      const selectedDate = `${year}-${month}-${day}`;

      const dataserv = {
        'shipment_id': this.shipment_id,
        "ship_date": selectedDate,
        "transporter": this.transporter,
        "delivery_time": this.delivery_date,
        "ready_time": this.ready_time,
        "close_time": this.close_time
      }

      await axios.post('/api/v1/book-shipment/', dataserv)
        .then(async response => {
          await this.ValidateShipment(this.shipment_id)
        })
        .catch(error => {
          this.booking_error = error.response?.data?.message || this.translate('booking_refused_generic')
          toast({
            message: error.response?.data?.message || "La réservation transporteur a échoué",
            type: 'is-danger',
            dismissible: true,
            pauseOnHover: true,
            duration: 5000,
            position: 'top-right',
          })
        })
      this.$store.commit('setIsLoading', false)
    },
    async getDelivery_time() {
      this.$store.commit('setIsLoading', true)

      const date = new Date(this.selectedDate);
      const toTwoDigits = (num) => {
        return num < 10 ? '0' + num : '' + num;
      };

      const day = toTwoDigits(date.getDate());
      const month = toTwoDigits(date.getMonth() + 1);
      const year = date.getFullYear();
      const selectedDate = `${year}-${month}-${day}`;

      const dataserv = {
        'shipment_id': this.shipment_id,
        "ship_date": selectedDate,
      }

      await axios.post('/api/v1/get-delivery-date/', dataserv)
        .then(response => {
          this.delivery_date = response.data['delivery_time']
          this.transporter = response.data['transporter']
        })
        .catch(error => {
          console.log(error)
        })
      this.$store.commit('setIsLoading', false)
    },
    formattedDeliveryTime() {
      if (this.delivery_date) {
        const dateParts = this.delivery_date.split('-');
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return formattedDate;
      }
      return '';
    },
    calculateAvailableStartTimes() {
      this.availableStartTimes = [];
      this.availableCloseTimes = [];

      const date = new Date(this.selectedDate);
      const toTwoDigits = (num) => {
        return num < 10 ? '0' + num : '' + num;
      };
      const day = toTwoDigits(date.getDate());
      const month = toTwoDigits(date.getMonth() + 1);
      const year = date.getFullYear();
      const selectedDate = `${year}-${month}-${day}`;

      // Getting and formatting today's date
      const todayyy = new Date();
      const todayDay = toTwoDigits(todayyy.getDate());
      const todayMonth = toTwoDigits(todayyy.getMonth() + 1);
      const todayYear = todayyy.getFullYear();
      const todayFormatted = `${todayYear}-${todayMonth}-${todayDay}`;

      if (selectedDate === todayFormatted) {

        const belgiumTimezone = 'Europe/Brussels';
        const optionsss = { timeZone: belgiumTimezone };
        const now = new Date().toLocaleString('en-US', optionsss);
        const currentHour = new Date(now).getHours();
        const currentMinute = new Date(now).getMinutes();

        if (currentMinute < 30) {
          for (let i = currentHour + 1; i < 17; i++) {
            this.availableStartTimes.push(`${i}:00`);
            this.availableStartTimes.push(`${i}:30`);
          }
        } else {
          this.availableStartTimes.push(`${currentHour + 1}:30`);
          for (let i = currentHour + 2; i < 17; i++) {
            this.availableStartTimes.push(`${i}:00`);
            this.availableStartTimes.push(`${i}:30`);
          }
        }
      } else {
        for (let i = 9; i < 17; i++) {
          if (i === 9) {
            this.availableStartTimes.push(`0${i}:00`);
            this.availableStartTimes.push(`0${i}:30`);
          } else {
            this.availableStartTimes.push(`${i}:00`);
            this.availableStartTimes.push(`${i}:30`);
          }

        }
      }
    },
    updateCloseTimeOptions() {
      this.availableCloseTimes = [];
      if (this.ready_time) {
        const startTime = this.ready_time.split(':');
        let hour = parseInt(startTime[0]);
        let minutes = parseInt(startTime[1]);

        if (minutes === 30) {
          for (let i = hour + 2; i <= 18; i++) {
            this.availableCloseTimes.push(`${i}:00`);
            if (i != 18) {
              this.availableCloseTimes.push(`${i}:30`);
            }
          }
        } else {
          for (let i = hour + 1; i <= 17; i++) {
            this.availableCloseTimes.push(`${i}:30`);
            this.availableCloseTimes.push(`${i + 1}:00`);
          }

        }
      }
    },
    checkFields() {
      if (!this.selectedDate) {
        toast({
          message: this.translate('ship_date_alert'),
          type: 'is-danger',
          dismissible: true,
          pauseOnHover: true,
          duration: 4000,
          position: 'top-right',
        })
      }
    },
    checkFields2() {
      if (!this.ready_time || !this.close_time) {
        toast({
          message: this.translate('pickup_time_alert'),
          type: 'is-danger',
          dismissible: true,
          pauseOnHover: true,
          duration: 4000,
          position: 'top-right',
        })
      }
    },
    async getServicePoint(user_id) {
      await axios.post('/api/v1/getservicepoint/')
        .then(response => {
          this.company = response.data
        })
        .catch(error => {
          console.log(JSON.stringify(error))
        })
    },
    AskValidation() {
      Swal.fire({
        icon: 'question',
        title: this.translate('shipment_validation'),
        text: this.translate('question_validation'),
        showCancelButton: true,
        confirmButtonText: this.translate('Yes'),
        cancelButtonText: this.translate('No'),
        confirmButtonColor: '#4BB543',
        cancelButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          this.bookShipment()
        }
      });
    },
    async ValidateShipment(shipment_id) {
      this.$store.commit('setIsLoading', true)
      await axios.post(`/api/v1/validate-shipment/${shipment_id}/`)
        .then(response => {
          toast({
            message: this.translate('shipment_validated'),
            type: 'is-success',
            dismissible: true,
            pauseOnHover: true,
            duration: 3000,
            position: 'top-right',
          })
          this.$router.push(`/print-documents/${shipment_id}`)
        })
        .catch(error => {
          toast({
            message: "Something went wrong",
            type: 'is-danger',
            dismissible: true,
            pauseOnHover: true,
            duration: 3000,
            position: 'top-right',
          })
        })
      this.$store.commit('setIsLoading', false)
    },
    logout() {
      axios.defaults.headers.common["Authorization"] = ""
      sessionStorage.removeItem("token")
      this.$store.commit('removeToken')
      this.$store.commit('removeAgent')
      this.$store.commit('clearShipment')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.custom {
  border: none;
  cursor: pointer;
  font-size: 15px;
  padding-bottom: 10px;

}

.custom:hover {
  color: #E5097F;
  font-weight: bold;
}


.active-item {
  color: #E5097F;
  font-weight: bold;
}

.img-item {
  margin-right: 8px;
}

.red-header tr {
  background-color: red;
  color: white;
}

.btn-new-ship {
  color: #E5097F;
  font-weight: bold;
  background-color: #fff;
  border: 2px solid #E5097F;
  border-radius: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 2px;
  padding-top: 2px;
}

.btn-new-ship:hover {
  background-color: #9b0656;
  color: white;
  border: 2px solid #9b0656;
}


.btn-more {
  color: #fff;
  font-weight: bold;
  background-color: #E5097F;
  border: 2px solid #E5097F;
  margin-left: 10px;
  border-radius: 20px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
}

.btn-more:hover {
  background-color: #9b0656;
  border: 2px solid #9b0656;
}

.btn-request {
  background-color: #BCF2C0;
  margin-left: 12px;
  border-radius: 20px;
  border: 2px solid #37B980;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
  font-weight: bold;
}

.btn-request:hover {
  background-color: #37B980;
  color: white;
}


.box-shadow-custom {
  box-shadow: 1px 1px 1px #aaa, -1px -1px 1px #aaa;
}


.bg-progress {
  background-color: #D5CB41;
}

.bg-delivered {
  background-color: #41D54B;
}

.validate-btn {
  padding: 8px;
  background-color: #14a60f;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #14a60f;
  user-select: none;
}

.validate-btn:hover {
  background-color: #0d8109;
  border: 1px solid #0d8109;
}

.modify-btn {
  padding: 8px;
  background-color: #0e5dc5;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #0e5dc5;
  user-select: none;
}

.modify-btn:hover {
  background-color: #0c4896;
  border: 1px solid #0c4896;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-body {
  display: flex;
  justify-content: space-between;
}

.column {
  width: 45%;
}

.modal-content {
  background-color: #FEEEF6;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 70%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>

<style scoped>
.booking-refused { margin: 10px 0; padding: 12px 14px; border-radius: 10px; background: #f8d7da; border: 1px solid #f1aeb5; color: #58151c; font-size: 14px; text-align: left; }
.btn-fix-desc { margin-top: 8px; background: #E5097F; color: #fff; font-weight: 600; border: none; border-radius: 20px; padding: 6px 16px; }
.btn-fix-desc:hover { background: #9b0656; color: #fff; }
</style>
